import { PathCommand } from 'opentype.js';

/**
 * Parse an SVG path data string into opentype.js PathCommand[] objects.
 * Supports: M, L, C, Q, Z commands (absolute coordinates only).
 * Handles negative numbers without separator (e.g. "7.71-2.37").
 */
export default function parseSvgPathToCommands(pathData: string): PathCommand[] {
  const commands: PathCommand[] = [];
  if (!pathData) {
    return commands;
  }

  const segments = pathData.match(/[MLCQZ][^MLCQZ]*/gi);
  if (!segments) {
    return commands;
  }

  segments.forEach((segment) => {
    const type = segment[0].toUpperCase();
    const nums = (
      segment
        .slice(1)
        .trim()
        .match(/-?\d+\.?\d*/g) || []
    ).map(Number);

    switch (type) {
      case 'M':
        commands.push({ type: 'M', x: nums[0], y: nums[1] });
        break;
      case 'L':
        commands.push({ type: 'L', x: nums[0], y: nums[1] });
        break;
      case 'C':
        commands.push({
          type: 'C',
          x1: nums[0],
          y1: nums[1],
          x2: nums[2],
          y2: nums[3],
          x: nums[4],
          y: nums[5],
        });
        break;
      case 'Q':
        commands.push({
          type: 'Q',
          x1: nums[0],
          y1: nums[1],
          x: nums[2],
          y: nums[3],
        });
        break;
      case 'Z':
        commands.push({ type: 'Z' });
        break;
      default:
        break;
    }
  });

  return commands;
}
